module.exports = __webpack_public_path__ + "img/header-background.6d452de0.svg";